var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCompleted)?_c('span',[_c('font-awesome-icon',{staticClass:"fa-fw",attrs:{"icon":['fas', 'check-circle']}}),_vm._v(" Completed ")],1):_c('span',[_vm._v(" In Progress ")])
}
var staticRenderFns = []

export { render, staticRenderFns }